/**
 * Shared sizing constants for contextual ACTION menus (i.e. popovers like
 * the row "more" menu or the list group action menu — the icon + label
 * vertical lists triggered from a more/share/etc. button).
 *
 * Use this min-width to keep action menus visually consistent across the
 * product. It is NOT intended for form selects, autocompletes, date
 * pickers, or other dropdown-style menus — those have their own UX rules
 * and may legitimately be narrower or wider.
 *
 * Based on Google Material Design's recommended menu min-width (256px),
 * which comfortably fits an icon + label + optional trailing element.
 */
// eslint-disable-next-line import/prefer-default-export
export const CONTEXTUAL_MENU_MIN_WIDTH = 256;
